<template>
  <div class="resource-menu">
    <div v-for="(item, index) in menu" :key="item.id">
      <div
        :class="{
          'menu-item': true,
          'cur-menu': menuIndex == index,
          expand: !item.hide,
        }"
        @click="changeMenu(index)"
      >
        <!-- {{ item.name }} -->
        {{ cutName(item.name) }}
      </div>
      <div v-if="index == menuIndex && !item.hide">
        <div v-for="(cItem, cIndex) in secMenuList[index]" :key="cItem.id">
          <div
            :class="{
              'sec-menu': true,
              'sec-menu-cur': secMenuIndex == cIndex,
            }"
            @click="changeSecMenu(cIndex)"
          >
            <img
              :class="{
                arrow: true,
                'arrow-cur': secMenuIndex == cIndex && !cItem.hide,
              }"
              :src="
                secMenuIndex == cIndex
                  ? require('../assets/arrow-cur.png')
                  : require('../assets/arrow.png')
              "
              alt=""
            />
            {{ cItem.name }}
          </div>
          <div
            class="third-menu-box"
            v-if="secMenuIndex == cIndex && !cItem.hide"
          >
            <div
              :class="{
                'third-menu': true,
                'third-menu-cur': thirdMenuIndex == tIndex,
              }"
              v-for="(tItem, tIndex) in thirdMenuList[index][cIndex]"
              :key="tItem.id"
              @click="changeThirdMenu(tIndex)"
            >
              {{ tItem.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCourse, group } from '../api/api'
export default {
  name: 'ResourceMenu',
  props: {
    menuIndexInit: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    menu: [],
    menuIndex: 0,
    secMenuList: [],
    secMenuIndex: -1,
    thirdMenuList: [],
    thirdMenuIndex: -1,
  }),
  mounted() {
    group().then((res) => {
      console.log('目录', res)
      res.data.data.forEach((item) => {
        item.hide = true
      })
      this.menu = res.data.data
      // // 获取二级目录
      console.log('this.menuIndexInit', this.menuIndexInit)
      this.changeMenu(this.menuIndexInit || 0)
    })
  },
  methods: {
    cutName(name) {
      return name.replace('教师指导用书', '')
    },
    changeMenu(index) {
      if (this.menuIndex == index) {
        // 点击的同一个
        if (this.menu[index].hide) {
          this.$set(this.menu[index], 'hide', false)
        } else {
          this.$set(this.menu[index], 'hide', true)
        }
      } else {
        // 点击的不同
        this.$set(this.menu[index], 'hide', false)
        this.$set(this.menu[this.menuIndex], 'hide', true)
      }
      this.menuIndex = index
      this.secMenuIndex = -1
      this.thirdMenuIndex = -1
      // 获取二级目录
      group({ pid: this.menu[index].id }).then((res) => {
        console.log('二级目录', res)
        res.data.data.forEach((item) => {
          item.hide = true
        })
        this.$set(this.secMenuList, index, res.data.data)
        if (!this.thirdMenuList[index]) {
          this.$set(this.thirdMenuList, index, [])
        }
      })
      sessionStorage.setItem('yey-menuIndexInit', index)

      this.$emit('menuChange', this.menu[index].id)
    },
    changeSecMenu(index) {
      if (this.secMenuIndex == index || this.secMenuIndex == -1) {
        console.log('同一个', this.secMenuIndex, index)
        console.log('同一个', this.secMenuList[this.menuIndex][index])
        // 点击的同一个
        if (this.secMenuList[this.menuIndex][index].hide) {
          this.$set(this.secMenuList[this.menuIndex][index], 'hide', false)
        } else {
          this.$set(this.secMenuList[this.menuIndex][index], 'hide', true)
        }
      } else {
        // 点击的不同的
        this.$set(this.secMenuList[this.menuIndex][index], 'hide', false)
        this.$set(
          this.secMenuList[this.menuIndex][this.secMenuIndex],
          'hide',
          true
        )
      }
      this.secMenuIndex = index
      this.thirdMenuIndex = -1
      group({ pid: this.secMenuList[this.menuIndex][index].id }).then((res) => {
        // console.log('三级目录', res)
        this.$set(this.thirdMenuList[this.menuIndex], index, res.data.data)
        this.$emit(
          'menuChange',
          this.menu[this.menuIndex].id,
          this.secMenuList[this.menuIndex][index].id
        )
      })
    },
    changeThirdMenu(index) {
      this.thirdMenuIndex = index
      this.$emit(
        'menuChange',
        this.menu[this.menuIndex].id,
        this.secMenuList[this.menuIndex][this.secMenuIndex].id,
        this.thirdMenuList[this.menuIndex][this.secMenuIndex][index].id
      )
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.resource-menu {
  width: 220px;
  height: calc(100vh - 100px);
  background-color: #fff;
  overflow-y: auto;
  overflow-x: hidden;
}
.menu-item {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 220px;
  height: 80px;
  padding-left: 52px;
  text-align: center;
  font-size: 18px;
  cursor: pointer;
  user-select: none;
  &::before {
    content: '';
    position: absolute;
    left: 26px;
    top: 35px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid #333333;
  }
}
.cur-menu {
  color: #0da1f1;
  background: rgba(92, 203, 247, 0.2);
  &::before {
    border-left: 6px solid #0da1f1;
  }
}
.expand {
  &::before {
    content: '';
    position: absolute;
    left: 23px;
    top: 37px;
    width: 0;
    height: 0;
    border-top: 6px solid #0da1f1;
    border-right: 7px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid transparent;
  }
}
.big-arrow {
  width: 9px;
  height: 14px;
  margin-left: 11px;
}
.big-arrow-cur {
  transform: rotate(90deg);
}
.arrow {
  width: 5px;
  height: 9px;
  margin-right: 9px;
}
.arrow-cur {
  transform: rotate(90deg);
}
.sec-menu {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 190px;
  height: 66px;
  padding-left: 21px;
  margin: 0 auto;
  line-height: 22px;
  color: #666;
  border-bottom: 1px solid #e8f1fa;
  user-select: none;
  cursor: pointer;
}
.sec-menu-cur {
  color: #0da1f1;
}
.third-menu-box {
  width: 190px;
  margin: 0 auto;
  border-bottom: 1px solid #e8f1fa;
}
.third-menu {
  box-sizing: border-box;
  width: 190px;
  height: 34px;
  padding-left: 49px;
  font-size: 14px;
  color: #808080;
  line-height: 34px;
  user-select: none;
  cursor: pointer;
}
.third-menu-cur {
  color: #0da1f1;
  background: rgba(92, 203, 247, 0.2);
}
</style>
